import * as React from "react";
import { SVGProps } from "react";

const Chainx = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 100 100"
    {...props}
  >
    <style>{".st0{fill:#172026}"}</style>
    <g id="Layer_2_1_">
      <g id="Layer_1-2">
        <path
          d="M50 45.7c-1 .3-2 .9-2.8 1.6-.7.7-1.2 1.7-1.5 2.7.3 1 .9 2 1.6 2.8.8.7 1.7 1.3 2.7 1.6 1-.3 2-.9 2.8-1.6.7-.7 1.3-1.7 1.6-2.7-.3-1-.9-2-1.6-2.8-.8-.8-1.7-1.3-2.8-1.6z"
          className="st0"
        />
        <path
          d="M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm24 64.1c-.2 2.6-1.3 4.9-3.1 6.7-3.9 3.9-10 4.3-13.5.7l-1.7-1.6 3.2-3.2 1.6 1.6c.8.7 1.8 1.2 2.9 1.1 3.2-.1 5.8-2.6 6.1-5.8.1-1.2-.3-2.4-1.1-3.3L61.1 53l-3.5 3.5c-.2.2-.4.3-.6.5l-.5.5L53 61l4.3 4.3-3.2 3.2-4.1-4.3-7.3 7.3c-1.8 1.8-4.2 2.7-6.8 2.4-2.6-.2-4.9-1.3-6.7-3.1-3.9-3.9-4.3-10-.7-13.5l1.6-1.6 3.2 3.2-1.6 1.6c-.7.8-1.2 1.8-1.1 2.9.1 3.2 2.6 5.8 5.8 6.1 1.2.1 2.4-.3 3.3-1.1l7.3-7.3-3.5-3.5c-.2-.2-.3-.4-.5-.6l-.5-.5L39 53l-4.3 4.3-3.2-3.2 4.3-4.3-7.3-7.3c-1.8-1.8-2.7-4.2-2.4-6.8.2-2.6 1.3-4.9 3.1-6.7 3.9-3.9 10-4.3 13.5-.7l1.6 1.6-3.2 3.2-1.6-1.6c-.8-.7-1.8-1.2-2.9-1.1-3.2.1-5.8 2.6-6.1 5.8-.1 1.2.3 2.4 1.1 3.3l7.3 7.3 3.5-3.5c.2-.2.4-.3.6-.5l.5-.5 3.5-3.5-4.3-4.3 3.2-3.2 4.3 4.3 7.3-7.3c1.8-1.8 4.2-2.7 6.8-2.4 2.6.2 4.9 1.3 6.7 3.1 3.9 3.9 4.3 10 .7 13.5l-1.6 1.7-3.2-3.2 1.6-1.6c.7-.8 1.2-1.8 1.1-2.9-.1-3.2-2.6-5.8-5.8-6.1-1.2-.1-2.4.3-3.3 1.1l-7.3 7.3 3.5 3.5c.2.2.3.4.5.6l.5.5 3.5 3.5 4.3-4.3 3.2 3.2-4.5 4.2 7.3 7.3c1.8 1.8 2.7 4.3 2.5 6.8z"
          className="st0"
        />
      </g>
    </g>
  </svg>
);

export default Chainx;
